// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-logo {
  max-height: 35px;
  width: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/layout/header/header.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,WAAA;AACF","sourcesContent":[".img-logo {\n  max-height: 35px;\n  width: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
